import React from 'react';
import styled from 'styled-components';
import { Type, white } from '@spotify-internal/encore-web';
import { Box } from '../../ui';
import { SearchBar } from '../../Search';
import { getBurst } from '../../utils';
import { useT } from '@spotify-internal/i18n-core';

const HELP_HOME_TRACK_CAT = 'helpHome';

type HelpHeaderProps = {
  backgroundColor?: string;
};

const HeaderWrapper = styled(Box)<HelpHeaderProps>`
  background-color: ${(props: any) => props.backgroundColor};
  color: ${white};
  justify-content: center;
  height: 300px;
  ${({ theme }) => getBurst(theme.help.banner.text)}
`;

const Header = styled.div`
  max-width: 984px;
  margin-left: auto;
  margin-right: auto;
`;

const Headline = styled(Type.h1).attrs({
  paddingBottom: '0.67em',
  variant: 'altoBrio',
  weight: 'bold',
})<{}>`
  padding-top: 100px;
`;

export type HelpHeaderType = {
  headline: string;
  backgroundColor: string;
};

export const HelpHeader: React.FC<HelpHeaderType> = ({
  headline = '',
  backgroundColor,
}) => {
  const t = useT();
  return (
    <HeaderWrapper backgroundColor={backgroundColor}>
      <Header>
        <Headline>{headline}</Headline>
        <SearchBar
          placeholder={t('FRODOR_dc8696', 'Search articles and resources', '')}
          contentTypes={['faq']}
          trackCategory="helpHeader"
          suggestCount={5}
          getSuggestUrl={sug => `${sug.url}?ref=sug_${HELP_HOME_TRACK_CAT}`}
        />
      </Header>
    </HeaderWrapper>
  );
};
